$(document).ready(() => {
  let headerOffset = $(".header").offset().top;

  // document.addEventListener('DOMContentLoaded', function() {
  //   const urlParams = new URLSearchParams(window.location.search);
  //
  //   if (urlParams.has('contact_posted') && urlParams.get('contact_posted') === 'true') {
  //     var targetElement = document.getElementById('contact_form2');
  //
  //     if (targetElement) {
  //       var footerMobileContent = targetElement.querySelector('.footer--mobile__item--content');
  //
  //       targetElement.scrollIntoView({
  //         behavior: 'smooth',
  //         block: 'start'
  //       });
  //     }
  //   }
  // });
  const urlParams = new URLSearchParams(window.location.search);
  if (window.innerWidth < 1082) {
    if (
      urlParams.has("contact_posted") &&
      urlParams.get("contact_posted") === "true"
    ) {
      var targetElement = $("#contact_form2");
      if (targetElement.length > 0) {
        var footerMobileContent = targetElement.find(
          ".footer--mobile__item--content"
        );
        footerMobileContent.slideToggle("fast");
        if (targetElement.length > 0) {
          $("html, body").animate(
            {
              scrollTop: targetElement.offset().top,
            },
            800
          );
        }
      }
    }
  } else {
    if (
      urlParams.has("contact_posted") &&
      urlParams.get("contact_posted") === "true"
    ) {
      var targetElement = $("#web-form");
      if (targetElement.length > 0) {
        if (targetElement.length > 0) {
          $("html, body").animate(
            {
              scrollTop: targetElement.offset().top,
            },
            800
          );
        }
      }
    }
  }

  if (window.innerWidth < 851) {
    if ($(window).scrollTop() > headerOffset + 92) {
      $(".header.fixed").addClass("show");
    } else {
      $(".header.fixed").removeClass("show");
    }
  } else {
    if ($(window).scrollTop() > headerOffset + 220) {
      $(".header.fixed").addClass("show");
    } else {
      $(".header.fixed").removeClass("show");
    }
  }

  $(window).scroll(function () {
    if (window.innerWidth < 851) {
      if ($(window).scrollTop() > headerOffset + 92) {
        $(".header.fixed").addClass("show");
      } else {
        $(".header.fixed").removeClass("show");
      }
    } else {
      if ($(window).scrollTop() > headerOffset + 220) {
        $(".header.fixed").addClass("show");
      } else {
        $(".header.fixed").removeClass("show");
      }
    }
  });

  // Handle opening slide-in menu when clicking on header or arrow
  $(".burger-menu__level-1-header").on("click", function (e) {
    const $header = $(this);
    const $panel = $header.closest(".burger-menu__level-1").find(".burger-menu__submenu-panel");

    // Only open if there's a panel with content
    if ($panel.length && $panel.find("ul").length > 0) {
      // If clicking on the link itself, let it navigate normally
      if ($(e.target).is("a") || $(e.target).closest("a").length) {
        // Check if clicking on the arrow area - if so, prevent navigation and open menu
        const $arrow = $header.find(".burger-menu__arrow");
        if ($arrow.length && ($(e.target).closest(".burger-menu__arrow").length || $(e.target).is(".burger-menu__arrow"))) {
          e.preventDefault();
          e.stopPropagation();
        } else {
          // Clicking on the link text - allow navigation
          return;
        }
      } else {
        // Clicking on header but not on link - open menu
        e.preventDefault();
        e.stopPropagation();
      }

      // Close any other open menus
      $(".burger-menu__submenu-panel").removeClass("open");
      $(".burger-menu__level-1").removeClass("menu-open");

      // Open this menu
      $panel.addClass("open");
      $header.closest(".burger-menu__level-1").addClass("menu-open");
      $("body").css("overflow", "hidden");
    }
  });

  // Handle closing slide-in menu with back button
  $(".burger-menu__back-button").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $panel = $(this).closest(".burger-menu__submenu-panel");
    $panel.removeClass("open");
    $panel.closest(".burger-menu__level-1").removeClass("menu-open");
    $("body").css("overflow", "initial");
  });

  // Handle fully closing the drawer with close button
  $(".burger-menu__close-button").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    // Close all slide-in menus
    $(".burger-menu__submenu-panel").removeClass("open");
    $(".burger-menu__level-1").removeClass("menu-open");

    // Close the main burger menu
    $(".header--burger").removeClass("open");
    $(".burger-menu").removeClass("show");
    $("body").css("overflow", "initial");
    $(".header1").show();
    $(".header2").show();
  });

  // Handle submenu accordion - make entire header clickable
  $(document).on("click", ".burger-menu__level-2-header--with-children", function (e) {
    const $header = $(this);
    const $arrow = $header.find(".burger-menu__arrow");
    const $link = $header.find("a");
    const $sublist = $header.closest(".burger-menu__level-2").find(".burger-menu__level-3-list");

    // Only handle if there's a sublist to toggle
    if ($sublist.length === 0) {
      return;
    }

    // If clicking directly on the link text, allow navigation
    if ($(e.target).is("a") || ($(e.target).closest("a").length && !$(e.target).closest(".burger-menu__arrow").length)) {
      return;
    }

    // Otherwise, toggle the accordion
    e.preventDefault();
    e.stopPropagation();

    if ($arrow.hasClass("active")) {
      $arrow.removeClass("active");
      $sublist.removeClass("open").slideUp("fast");
    } else {
      $arrow.addClass("active");
      $sublist.addClass("open").slideDown("fast");
    }
  });

  // Also handle direct clicks on the arrow icon
  $(document).on("click", ".burger-menu__level-2-header--with-children .burger-menu__arrow", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $arrow = $(this);
    const $header = $arrow.closest(".burger-menu__level-2-header--with-children");
    const $sublist = $header.closest(".burger-menu__level-2").find(".burger-menu__level-3-list");

    if ($sublist.length > 0) {
      if ($arrow.hasClass("active")) {
        $arrow.removeClass("active");
        $sublist.removeClass("open").slideUp("fast");
      } else {
        $arrow.addClass("active");
        $sublist.addClass("open").slideDown("fast");
      }
    }
  });

  let container = $(".footer--info ul");
  container.scrollLeft((container[0].scrollWidth - container.innerWidth()) / 2);

  let container2 = $(".header--info ul");
  container2.scrollLeft(
    (container2[0].scrollWidth - container2.innerWidth()) / 2
  );

  $(".footer--mobile__item--header").on("click", function () {
    const $th = $(this);
    $th.next().slideToggle("fast");
  });

  $(".section-collection-items1 .section-collection-items").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    appendDots: $(".section-collection-items1 .collection-dots"),
    prevArrow: $(".section-collection-items1 .collection-arrow-prev"),
    nextArrow: $(".section-collection-items1 .collection-arrow-next"),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          appendDots: $(
            ".section-collection-items1 .section-slide--dots__mobile"
          ),
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 850,
        settings: {
          appendDots: $(
            ".section-collection-items1 .section-slide--dots__mobile"
          ),
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });
  $(".section-collection-items2 .section-collection-items").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    appendDots: $(".section-collection-items2 .collection-dots"),
    prevArrow: $(".section-collection-items2 .collection-arrow-prev"),
    nextArrow: $(".section-collection-items2 .collection-arrow-next"),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          appendDots: $(
            ".section-collection-items2 .section-slide--dots__mobile"
          ),
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 850,
        settings: {
          appendDots: $(
            ".section-collection-items2 .section-slide--dots__mobile"
          ),
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });
  $(".section-collection-items3 .section-collection-items").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    appendDots: $(".section-collection-items3 .collection-dots"),
    prevArrow: $(".section-collection-items3 .collection-arrow-prev"),
    nextArrow: $(".section-collection-items3 .collection-arrow-next"),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          appendDots: $(
            ".section-collection-items3 .section-slide--dots__mobile"
          ),
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 850,
        settings: {
          appendDots: $(
            ".section-collection-items3 .section-slide--dots__mobile"
          ),
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });

  $(".section-products-items").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: true,
    appendDots: $(".section-products-dots"),
    prevArrow: $(".section-arrow-prev"),
    nextArrow: $(".section-arrow-next"),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });

  if (window.innerWidth <= 1080) {
    $(".footer--info ul").slick({
      slidesToScroll: 1,
      slidesToShow: 3,
      arrows: false,
      variableWidth: true,
      autoplay: true,
      autoplaySpeed: 6000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: true,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 6000,
          },
        },
      ],
    });
  }

  $(".header--info__mobile").slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    centerMode: true,
    arrows: false,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 6000,
    infinite: true,
  });

  $(".header1 .header--burger").on("click", function () {
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $(".burger-menu").removeClass("show");
      // Close any open slide-in menus
      $(".burger-menu__submenu-panel").removeClass("open");
      $(".burger-menu__level-1").removeClass("menu-open");
      $("body").css("overflow", "initial");
      $(".header2 ").show();
    } else {
      $(this).addClass("open");
      $(".burger-menu").addClass("show");
      $("body").css("overflow", "hidden");
      $(".header2 ").hide();
    }
  });

  $(".header2 .header--burger").on("click", function () {
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $(".burger-menu").removeClass("show");
      // Close any open slide-in menus
      $(".burger-menu__submenu-panel").removeClass("open");
      $(".burger-menu__level-1").removeClass("menu-open");
      $("body").css("overflow", "initial");
      $(".header1 ").show();
    } else {
      $(this).addClass("open");
      $(".burger-menu").addClass("show");
      $("body").css("overflow", "hidden");
      $(".header1 ").hide();
    }
  });

  $(".read-more").on("click", function () {
    if (!$(".section-text--wrapper").hasClass("open")) {
      $(".section-text--wrapper").addClass("open");
      $(this).find(".read-more-text").hide();
      $(this).find(".read-less-text").show();
    } else {
      $(".section-text--wrapper").removeClass("open");
      $(this).find(".read-less-text").hide();
      $(this).find(".read-more-text").show();
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  // const addToCartButtons = document.querySelectorAll('.button-add');

  // addToCartButtons.forEach(button => {
  //   button.addEventListener('click', function () {
  //     const productId = button.getAttribute('data-product-id');
  //     addToCart(productId);
  //   });
  // });

  function addToCart(productId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: productId,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        fetch("/cart.js")
          .then((response) => response.json())
          .then((cartData) => {
            window.location.href = "/cart";
          });
      })
      .catch((error) => console.error("Ошибка:", error));
  }

  $(".tag-filters__selected").on("click", function () {
    if ($(".tag-filters__wrapper").hasClass("open")) {
      $(".tag-filters__wrapper").removeClass("open");
    } else {
      $(".tag-filters__wrapper").addClass("open");
    }
  });

  // $('#SortByPrice').change(function() {
  //   var selectedValue = $(this).val();
  //   var url = new URL(window.location.href);
  //   url.searchParams.set('sort_by', selectedValue);
  //   window.location.href = url.toString();
  // });

  $(".sub-collection--slider").slick({
    variableWidth: true,
    draggable: true,
    arrows: true,
    dots: false,
    infinite: false,
    nextArrow: $('.sub-collection--slider__arrow'),
    prevArrow: $('.sub-collection--slider__arrow-prev')
  });

  /*
  $('.sub-collection--slider__arrow-prev').hide()
  $('.sub-collection--slider .slick-list').attr('style', 'margin-left: 0 !important');

  if (window.innerWidth > 1081) {
    $('.sub-collection--slider').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      if (currentSlide === 0){
        $('.sub-collection--slider__arrow-prev').hide()
        $('.sub-collection--slider .slick-list').attr('style', 'margin-left: 0 !important');
      }else{
        $('.sub-collection--slider__arrow-prev').show()
        $('.sub-collection--slider .slick-list').attr('style', 'margin-left: 50px !important');
      }
    });
  }
  */

  if (1 == 0) {
    $("#sort-by").select2({
      minimumResultsForSearch: -1,
    });

    $("#sort-by").on("select2:selecting", function (e) {
      Shopify.queryParams.sort_by = e.params.args.data.id;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    });

    $("#SortByPrice").select2({
      minimumResultsForSearch: -1,
    });
    $("#SortByPrice").on("select2:selecting", function (e) {
      Shopify.queryParams.sort_by = e.params.args.data.id;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    });

    $("#SortBy").select2({
      minimumResultsForSearch: -1,
    });

    $("#SortBy").on("select2:selecting", function (e) {
      Shopify.queryParams.sort_by = e.params.args.data.id;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    });

    $(".select2-selection__arrow b").remove();
    $(".select2-selection__arrow")
      .append(`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20px"
                 height="14px" viewBox="0 -4.5 20 20" version="1.1">
              <title>arrow_down [#338]</title>
              <desc>Created with Sketch.</desc>
              <defs>

              </defs>
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Dribbble-Light-Preview" transform="translate(-220.000000, -6684.000000)" fill="#575757">
                  <g id="icons" transform="translate(56.000000, 160.000000)">
                    <path
                      d="M164.292308,6524.36583 L164.292308,6524.36583 C163.902564,6524.77071 163.902564,6525.42619 164.292308,6525.83004 L172.555873,6534.39267 C173.33636,6535.20244 174.602528,6535.20244 175.383014,6534.39267 L183.70754,6525.76791 C184.093286,6525.36716 184.098283,6524.71997 183.717533,6524.31405 C183.328789,6523.89985 182.68821,6523.89467 182.29347,6524.30266 L174.676479,6532.19636 C174.285736,6532.60124 173.653152,6532.60124 173.262409,6532.19636 L165.705379,6524.36583 C165.315635,6523.96094 164.683051,6523.96094 164.292308,6524.36583"
                      id="arrow_down-[#338]">

                    </path>
                  </g>
                </g>
              </g>
            </svg>`);
  }
  if (window.innerWidth === 768) {
    $(".select2-selection__arrow svg").remove();
    $(".select2-selection__arrow")
      .append(`<svg xmlns="http://www.w3.org/2000/svg" width="13px" height="11px" viewBox="-0.5 0 25 25" fill="none">
                <path d="M12 7.82001H22" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M2 7.82001H4" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M20 16.82H22" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M2 16.82H12" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path
                  d="M8 11.82C10.2091 11.82 12 10.0291 12 7.82001C12 5.61087 10.2091 3.82001 8 3.82001C5.79086 3.82001 4 5.61087 4 7.82001C4 10.0291 5.79086 11.82 8 11.82Z"
                  stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path
                  d="M16 20.82C18.2091 20.82 20 19.0291 20 16.82C20 14.6109 18.2091 12.82 16 12.82C13.7909 12.82 12 14.6109 12 16.82C12 19.0291 13.7909 20.82 16 20.82Z"
                  stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>`);
  }

  $(".slider-galeria").on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      $(".pdp-slider-counter").text(i + "/" + slick.slideCount);
    }
  );
  let slides = $(".slider-galeria-thumbs_slide").length;

  // $('.slider-galeria').on('afterChange', function (event, slick, currentSlide, nextSlide) {
  //   if (currentSlide === 0 && slides > 6) {
  //     $('.slider-galeria-thumbs').slick('slickGoTo', 0)
  //   }
  // });
  if (slides <= 7) {
    $(".slider-galeria-thumbs_slide-image").first().addClass("slick-current");
  }
  $(".slider-galeria").on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      console.log(currentSlide);
      let slideElem = document.querySelector(
        `.slider-galeria_slide[data-slick-index="${currentSlide}"]`
      );
      if (slideElem) {
        let type = slideElem.getAttribute("data-media-type");
        if (type == "video") {
          let video = slideElem.querySelector("video");
          if (video.paused) {
            video.play();
          }
        }
      }

      if (slides <= 7) {
        console.log(
          "test:",
          $(".slider-galeria-thumbs_slide-image").eq(currentSlide)
        );
        if ($(".slider-galeria-thumbs_slide-image").eq(currentSlide).length) {
          $(".slider-galeria-thumbs_slide-image").removeClass("slick-current");
          $(".slider-galeria-thumbs_slide-image")
            .eq(currentSlide)
            .addClass("slick-current");
        }
      }
    }
  );
  $(".slider-galeria-thumbs_slide").on("click", function () {
    if (slides <= 7) {
      $(".slider-galeria-thumbs_slide-image").removeClass("slick-current");
      $(".slider-galeria").slick(
        "slickGoTo",
        Number($(this).attr("data-slide")) - 1
      );
      $(".slider-galeria-thumbs_slide-image")
        .eq(Number($(this).attr("data-slide")) - 1)
        .addClass("slick-current");
    }
  });

  if (slides <= 7) {
    $(".slider-galeria").slick({
      arrows: true,
      infinite: false,
      dots: true,
      appendDots: $(".pdp-slider-dots"),
      prevArrow: $(".pdp-slider-arrow__left"),
      nextArrow: $(".pdp-slider-arrow__right"),
    });
    $(".slider-galeria-thumbs__wrapper").addClass("off");
  } else {
    $(".slider-galeria").slick({
      arrows: true,
      infinite: false,
      asNavFor: ".slider-galeria-thumbs",
      dots: true,
      appendDots: $(".pdp-slider-dots"),
      prevArrow: $(".pdp-slider-arrow__left"),
      nextArrow: $(".pdp-slider-arrow__right"),
    });
    $(".slider-galeria-thumbs").slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      arrows: true,
      asNavFor: ".slider-galeria",
      infinite: false,
      vertical: true,
      verticalSwiping: true,
      focusOnSelect: true,
      draggable: false,
      adaptiveHeight: true,
      prevArrow: $(".slider-galeria-thumbs__arrow.prev"),
      nextArrow: $(".slider-galeria-thumbs__arrow.next"),
    });
  }

  if (window.innerWidth > 1080) {
    if (
      $(".product__description .product__description__inner").height() < 140
    ) {
      $(".product__description").removeClass("hide");
      $(".product__description--more").hide();
    } else {
      $(".product__description").addClass("hide");
      $(".product__description--more").show();
    }
  } else {
    if (
      $(".product__description .product__description__inner").height() < 125
    ) {
      $(".product__description").removeClass("hide");
      $(".product__description--more").hide();
    } else {
      $(".product__description").addClass("hide");
      $(".product__description--more").show();
    }
    $(".pdp-slider-arrow__left").hide();

    $(".slider-galeria").on(
      "afterChange",
      function (event, slick, currentSlide, nextSlide) {
        if (currentSlide === 0) {
          $(".pdp-slider-arrow__left").hide();
        } else {
          $(".pdp-slider-arrow__left").show();
        }

        if (currentSlide === slides - 1) {
          $(".pdp-slider-arrow__right").hide();
        } else {
          $(".pdp-slider-arrow__right").show();
        }
      }
    );
  }

  $(".product__description--more").on("click", function () {
    $(".product__description").toggleClass("hide");
    $(".product__info-container").toggleClass("show");

    if ($(".product__description").hasClass("hide")) {
      $(this).find(".read-less-text").hide();
      $(this).find(".read-more-text").show();
    } else {
      $(this).find(".read-more-text").hide();
      $(this).find(".read-less-text").show();
    }
  });

  if (window.innerWidth <= 540) {
    $(".product-container-bottom__left").slick({
      centerMode: true,
      variableWidth: true,
    });
  }
});

/* Javascript - Show cart drawer when product added to cart */
document.addEventListener("theme:cart:popdown", (e) => {
  const listener = (e) => {
    document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
      new CustomEvent("theme:drawer:open", {
        bubbles: false,
      })
    );
    document.removeEventListener("theme:cart:change", listener);
  };
  document.addEventListener("theme:cart:change", listener);
});

/* end */
